import Cookies from 'js-cookie';

export default function getCookieSafe(cookieName: string): string {
    return Cookies.get(cookieName) ?? '';
}
